import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import Slider from 'react-slick';
import PropTypes from 'prop-types';

import Routes from 'resources/routes.json';
import history from 'navigation/history';

import Button from 'components/UI/button/button';

import { COLLECTION } from 'utils/enumerator/enum-loan-phase';
import { isMobile } from 'utils/helper/page-behavior-helper';

import { CustomerMenu } from '../menu';
import SliderItem from './slider-item';

import { sliderSettings } from './slider-settings';

import './index.scss';
import { GET_TEMP_TOKEN_SUCCESS, getTempToken } from '../../../../store/actions/auth-actions';

function renderLoanContent(loanPhase, userId, withMobileCollateral, setShowCurrentSlip, multiplikLink) {
  const INSURANCE_CTA_URL = 'https://www.supersim.com.br/como-solicitar-emprestimo#segurosupersim';
  const RESEARCH_CTA_URL = 'https://forms.gle/USxCa7WRTTPhZfyM7';
  const APP_CTA_URL = 'https://play.google.com/store/apps/details?id=br.com.supersim.androidapp';

  return (
    <div className="slider-container">
      <Slider {...sliderSettings}>
        {loanPhase === COLLECTION && (
          <SliderItem
            title="Parcela atrasada!"
            description="Entre em contato conosco."
            image={withMobileCollateral ? "/image/phone_blocked.png" : "/image/parcela_atrasada_banner.png"}
            altImagem="Imagem de celular bloqueado"
            customMarginBottom={95}
            buttonText="Pague já"
            onClickButton={setShowCurrentSlip}
          />
        )}

        <SliderItem
          description="Quer ganhar uma renda extra?"
          buttonText="Eu quero!"
          image="/image/img_banner_multiplik.png"
          altImagem="Cedulas de dinheiro"
          onClickButton={() => window.open(multiplikLink, '_blank')}
          imageWidth={isMobile() && 150}
          buttonId="multiplikBannerButton"
        />

        {/* hide if loan installment late */}
        {loanPhase !== COLLECTION && (
          <SliderItem
            title="Novidade"
            description="Agora você tem descontos exclusivos!"
            buttonText="Saiba mais"
            image="/image/img_ticket.png"
            altImagem="Imagem de cupom de desconto"
            onClickButton={() => history.push(Routes.CUSTOMER_SHOP_PAGE.DEFAULT)}
            imageWidth={isMobile() && 140}
            customMarginBottom={!isMobile() && 80}
          />
        )}
        <SliderItem
          title="Novidade"
          description="Proteja seu empréstimo com o SuperSeguro."
          buttonText="Saiba mais"
          image="/image/img_umbrella.png"
          altImagem="Imagem de guarda chuva"
          onClickButton={() => window.open(INSURANCE_CTA_URL, '_blank')}
        />

        <SliderItem
          title="#PESQUISA"
          description="Inove o mercado de crédito conosco. É só 5 minutinhos!"
          buttonText="Participar"
          image="/image/img_lupa.png"
          altImagem="Imagem de lupa"
          onClickButton={() => window.open(RESEARCH_CTA_URL, '_blank')}
        />

        {/* TODO: Enable slider when app is on google play */}
        {/* <SliderItem
          title="Google play"
          description="Tenha mais controle do seu empréstimo. "
          buttonText="Baixar app"
          image={SuperSimLogoImg}
          altImagem="Logo da SuperSim"
          onClickButton={() => window.open(APP_CTA_URL, '_blank')}
        /> */}

        <SliderItem
          title="Boleto"
          description="Retire seu boleto diretamente pelo site, é fácil e rápido!"
          alternativeDescription="Se tiver dúvidas, acesse nosso chat."
          image="/image/boleto.png"
          altImagem="Imagem de boleto"
          imageWidth={!isMobile() && 240}
          customMarginBottom={!isMobile() && 80}
        />
      </Slider>
    </div>
  );
}

function MultiplikContent() {
  return (
    <div className="header-content">
      <div className="header-content-column">
        <div className="header-content-text">
          <p>Quer ganhar uma renda extra?</p>
        </div>
        <div className="header-content-button">
          <NavLink to={Routes.CUSTOMER_LOAN_MULTIPLIK_PAGE.DEFAULT}>
            <Button>Eu quero</Button>
          </NavLink>
        </div>
      </div>
      <div className="header-content-image-wrapper">
        <div className="header-content-image bills">
          <img src="/image/notas_cem.png" alt="" className="bills" />
        </div>
      </div>
    </div>
  );
}

function CustomerHeader({ loanPhase, personName, setShowCurrentSlip, withMobileCollateral }) {
  const names = (personName || '').split(' ');
  const firstName = names.length > 0 ? names[0] : '';
  const userId = useSelector((state) => state?.personalLending?.loan?.application?.personal?.id);
  const device = useSelector((state) => state?.customer?.device);
  const dispatch = useDispatch()
  const [multiplikLink,  setMultiplikLink] = useState("");


  function getMultiplikLink() {
    dispatch(getTempToken(device)).then((response) => {
    let tempToken = ""
    if(response.type == GET_TEMP_TOKEN_SUCCESS){
      tempToken = response.payload?.tempToken?.toString()
    }
    setMultiplikLink(`https://vendedor.supersim.com.br/multiplik/novo?utm_source=supersim&utm_medium=recorrente&utm_campaign=default-adsense&user=${userId}&tempToken=${tempToken}`)
    });
  }

  useEffect(() =>{
    getMultiplikLink()
  },[])

  return (
    <div className={loanPhase === COLLECTION ? 'header late' : 'header'}>
      <div className="nav-wrapper">
        <div className="navbar">
          <div className="logo">
            <img src="/image/supersim_logo.png" alt="SuperSim logo" />
          </div>

          <div className="menu">
            <CustomerMenu />
          </div>
        </div>

        <div className="header-wrapper">
          {firstName ? (
            <h3 className="greeting">
              Olá, <span className="customer-name">{firstName}!</span>
            </h3>
          ) : (
            <h3 className="greeting">Olá!</h3>
          )}

          {renderLoanContent(loanPhase, userId, withMobileCollateral, setShowCurrentSlip, multiplikLink)}
        </div>
      </div>
    </div>
  );
}

CustomerHeader.propTypes = {
  loanPhase: PropTypes.number,
  personName: PropTypes.string,
};

export { CustomerHeader };
